import { useEffect } from "react";
import { useBeforeUnload, useLocation, useNavigate } from "react-router-dom";

import useAuthenticatedUser from "../useAuthenticatedUser";

import constants from "@libs/acp/common/constants";

const useNavigationGuard = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const { authenticatedUser } = useAuthenticatedUser();

	const requiredUpdates = authenticatedUser?.customer?.required_updates;
	const shouldBlockNavigation = Boolean(
		requiredUpdates && requiredUpdates.length > 0,
	);

	const conflictType = shouldBlockNavigation
		? (requiredUpdates?.[0] as string)
		: "";

	const hasTemporaryCheckoutRedirect = sessionStorage.getItem(
		"temp_checkoutRedirect",
	);

	const hasTemporaryClosedAgreementRedirect = sessionStorage.getItem(
		"temp_closedAgreementRedirect",
	);

	const lockedPath =
		conflictType === "account_ncad" && hasTemporaryCheckoutRedirect
			? hasTemporaryCheckoutRedirect
			: conflictType === "account_ncad" && hasTemporaryClosedAgreementRedirect
				? hasTemporaryClosedAgreementRedirect
				: constants.conflictingEmailRedirects[conflictType];

	useBeforeUnload(
		shouldBlockNavigation
			? (e) => {
					e.preventDefault();
					e.returnValue = "";
				}
			: () => null,
	);

	const allowedPaths = [
		lockedPath?.split("?")[0],
		constants.pageNames.updateContactSuccess,
	];

	useEffect(() => {
		if (
			shouldBlockNavigation &&
			lockedPath &&
			location.pathname !== lockedPath.split("?")[0]
		) {

      const state =  lockedPath.includes("/checkout/oferta")
					? { isFromCheckoutRedirect: true }
					: undefined;

			navigate(lockedPath, {
				replace: true,
				state
			});
		}
	}, [shouldBlockNavigation]);

	return null;
};

export default useNavigationGuard;
